import { type RefObject, useEffect, useLayoutEffect } from 'react';

function medir(campo: HTMLTextAreaElement, maximo: number) {
  campo.style.height = 'auto';
  campo.style.height = `${Math.min(campo.scrollHeight, maximo)}px`;
  campo.style.overflowY = campo.scrollHeight > maximo ? 'auto' : 'hidden';
}

/**
 * Caixa de texto que cresce com o conteúdo (até `maximo` px). Mede de novo
 * quando a largura muda: janela redimensionada, ou aberta ainda sem
 * largura (aba escondida), quando a medida da primeira vez sai errada.
 */
export function useAutoAltura(
  ref: RefObject<HTMLTextAreaElement | null>,
  valor: string,
  maximo = 320,
) {
  useLayoutEffect(() => {
    if (ref.current) medir(ref.current, maximo);
  }, [ref, valor, maximo]);

  useEffect(() => {
    const campo = ref.current;
    if (!campo || typeof ResizeObserver === 'undefined') return;
    let largura = campo.clientWidth;
    const observador = new ResizeObserver(() => {
      if (campo.clientWidth === largura) return;
      largura = campo.clientWidth;
      medir(campo, maximo);
    });
    observador.observe(campo);
    return () => observador.disconnect();
  }, [ref, maximo]);
}
